import React, { useEffect, useState, useRef } from "react";
import { Popup,Button } from 'react-vant';
import './sendEmailPop.scss';

const sendEmailPop = ({ emailPopStatus,emailValue,clickEmailPop, submitEmail }) => {
    const [emailPop, setEmailPop] = useState(false);
    const [email, setEmail] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);

    useEffect(()=>{
        setEmailPop(emailPopStatus)
        setEmail(emailValue)
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isValidEmail = !emailPattern.test(emailValue);
        setIsValidEmail(isValidEmail);
    },[emailPopStatus])
    const hideEmailPop =()=>{
        clickEmailPop(false);
    }
    const handleEmailChange = (event) => {
        const email = event.target.value;
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isValidEmail = !emailPattern.test(email);
        setIsValidEmail(isValidEmail);
        setEmail(email);
    };
    const handleEmailSubmit = () => {
        submitEmail(email);
        clickEmailPop(false);
    }

    return (
        <Popup
            visible={emailPop}
            closeable
            className="sendEmail_"
            position='center'
            round
            closeOnClickOverlay={false}
            onClose={hideEmailPop}
        >
            <div className="sendEmail_box">
                <span className="email_title">Fortune report</span>
                <span className="email_content">Your fortune interpretation report is ready and will be sent to your email via email! 🔮</span>
                <input
                    className="email_input"
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Please enter your email address"
                />
                <Button className="send_email_btn" style={{ width: '80%', height: '45px', marginTop: '15px', borderRadius: '10px' }} color='#F4A632' type='primary' block disabled={isValidEmail} onClick={handleEmailSubmit}>
                    Submit
                </Button>
            </div>
        </Popup>
    )
}
export default sendEmailPop;